module.exports = __webpack_public_path__ + "static/media/php-beginner.5eadedcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/php-beginner.png
// module id = 1461
// module chunks = 146